"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _vue = _interopRequireDefault(require("vue"));
var _webTrackBrowser = _interopRequireDefault(require("@aliyun-sls/web-track-browser"));
var _webStsPlugin = _interopRequireDefault(require("@aliyun-sls/web-sts-plugin"));
/*
 * @Author: 张月平 sam.zhang@neo-digitex.com
 * @Date: 2025-07-09 15:10:56
 * @LastEditors: 张月平 sam.zhang@neo-digitex.com
 * @LastEditTime: 2025-07-19 10:02:42
 * @FilePath: \sihong-website\plugins\log.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

// import { getStsToken } from '@/config/url'
var getStsToken = 'https://www.theinniverse.com.cn/scm/app/sts/getStsToken';
var opts = {
  host: 'cn-hongkong.log.aliyuncs.com',
  // 所在地域的服务入口。例如cn-hangzhou.log.aliyuncs.com
  project: 'theinniverse-com-production',
  // Project名称。
  logstore: 'scm-frontend',
  // Logstore名称。
  time: 10,
  // 发送日志的时间间隔，默认是10秒。
  count: 10,
  // 发送日志的数量大小，默认是10条。
  topic: 'scm',
  // 自定义日志主题。
  source: 'source',
  tags: {
    tags: 'tags'
  }
};
var stsOpt = {
  accessKeyId: '',
  accessKeySecret: '',
  securityToken: '',
  // 以下是一个 stsToken 刷新函数的简单示例
  refreshSTSToken: function refreshSTSToken() {
    return new Promise(function (resolve, reject) {
      var xhr = new window.XMLHttpRequest();
      xhr.open('GET', getStsToken, true);
      xhr.send();
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            var credential = JSON.parse(xhr.response).body.credentials;
            // 函数的本质目的：设置 stsOpt 的临时密钥和令牌。
            stsOpt.accessKeyId = credential.accessKeyId;
            stsOpt.accessKeySecret = credential.accessKeySecret;
            stsOpt.securityToken = credential.securityToken;
            console.log(stsOpt, 'stsOpt');
            resolve();
          } else {
            reject('Wrong status code.');
          }
        }
      };
    });
  }
  // refreshSTSTokenInterval: 300000,
  // stsTokenFreshTime: undefined,
};

// 创建 Tracker
var tracker = new _webTrackBrowser.default(opts);
// 创建 sts 插件
var stsPlugin = (0, _webStsPlugin.default)(stsOpt);
// 使用 sts 插件
tracker.useStsPlugin(stsPlugin);
// 以单条日志上传为例
// tracker.send({
//   message: 'scm测试'

// })

window.onerror = function (message, source, lineno, colno, error) {
  console.error("Error: ".concat(message, " at ").concat(source, ":").concat(lineno, ":").concat(colno));
  // 发送到后端日志服务
  tracker.send({
    message: message,
    source: source,
    lineno: lineno,
    colno: colno,
    error: error,
    type: 'CONSOLE·onerror',
    date: "".concat(new Date().toLocaleDateString(), " ").concat(new Date().toLocaleTimeString(), " ").concat(new Date().toLocaleTimeString())
  });
};
window.addEventListener('unhandledrejection', function (event) {
  tracker.send({
    message: event.reason,
    type: 'console·全局报错',
    date: "".concat(new Date().toLocaleDateString(), " ").concat(new Date().toLocaleTimeString(), " ").concat(new Date().toLocaleTimeString())
  });
});
_vue.default.config.errorHandler = function (err, vm, info) {
  tracker.send({
    message: info,
    err: err,
    type: 'console·vue报错',
    date: "".concat(new Date().toLocaleDateString(), " ").concat(new Date().toLocaleTimeString(), " ").concat(new Date().toLocaleTimeString())
  });
  // 处理错误
};